module.exports = __webpack_public_path__ + "img/vi.eedfab20.png";